/* -----------------------------------------------------------
   OPEN CART DRAWER WHEN CLICKING HEADER CART LINK
----------------------------------------------------------- */
document.addEventListener('click', function (event) {
  var cartLink = event.target.closest('.t4x-header__icon-btn--cart');
  if (!cartLink) return;

  // prevent going to /cart
  event.preventDefault();

  // Correct Minimog event to OPEN the drawer
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: true }
    })
  );
});

/* -----------------------------------------------------------
   CLOSE CART DRAWER WHEN CLICKING CLOSE ICON OR OVERLAY
----------------------------------------------------------- */
document.addEventListener('click', function (event) {
  var closeBtn = event.target.closest('.m-cart-drawer__close');
  var overlay = event.target.closest('.m-cart__overlay');
  if (!closeBtn && !overlay) return;

  // Correct Minimog event to CLOSE drawer
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { open: false }
    })
  );
});

// Helper: update header cart text everywhere
  function hosomeUpdateHeaderCartCount(count) {
    count = count || 0;

    // Your custom header link text: "Cart (X)"
    var cartText = document.querySelector('.t4x-header__cart-badge');
    if (cartText) {
      cartText.textContent = count;
    }

    // Optional: if you ever add bubbles like <span data-cart-count>
    var countBubbles = document.querySelectorAll('[data-cart-count]');
    countBubbles.forEach(function (el) {
      el.textContent = count;
    });
  }

  // 1) When Minimog says "cart updated" (drawer, product form, etc.)
  document.addEventListener('cart:updated', function (evt) {
    var cart = evt.detail && evt.detail.cart;
    if (cart && typeof cart.item_count !== 'undefined') {
      hosomeUpdateHeaderCartCount(cart.item_count);
    } else {
      // Fallback – fetch cart if for some reason cart object is missing
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cartData) {
          hosomeUpdateHeaderCartCount(cartData.item_count);
        })
        .catch(function (err) {
          console.error('Failed to sync header cart count', err);
        });
    }
  });

  // 2) Optional: sync once on page load too
  document.addEventListener('page:loaded', function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cartData) {
        hosomeUpdateHeaderCartCount(cartData.item_count);
      })
      .catch(function (err) {
        console.error('Failed to sync header cart count on load', err);
      });
  });


document.addEventListener('DOMContentLoaded', function () {
  /* ==============================
     Custom scrollbar + dragging
     for 4x4 shop-by-category
     ============================== */

  document.querySelectorAll('.t4x-shopcat').forEach(section => {
    const scrollContainer = section.querySelector('.t4x-shopcat__scroller');
    const customScrollbar = section.querySelector('.t4x-shopcat__track');
    const customThumb = section.querySelector('.t4x-shopcat__track-bar');

    if (!scrollContainer || !customScrollbar || !customThumb) return;

    let isDragging = false;
    let dragStartX;
    let thumbStartX;

    const getThumbWidth = () => customThumb.offsetWidth || 1;

    const updateThumbPosition = () => {
      const scrollWidth = scrollContainer.scrollWidth;
      const containerWidth = scrollContainer.clientWidth;
      const scrollLeft = scrollContainer.scrollLeft;

      const maxScrollLeft = scrollWidth - containerWidth;
      if (maxScrollLeft <= 0) {
        // No overflow → thumb stays at start
        customThumb.style.transform = 'translateX(0px)';
        return;
      }

      const thumbWidth = getThumbWidth();
      const maxThumbLeft = customScrollbar.clientWidth - thumbWidth;

      const thumbLeft = (scrollLeft / maxScrollLeft) * maxThumbLeft;
      customThumb.style.transform = `translateX(${thumbLeft}px)`;
    };

    const moveThumb = (deltaX) => {
      const thumbWidth = getThumbWidth();
      const maxThumbLeft = customScrollbar.clientWidth - thumbWidth;
      const newThumbLeft = Math.min(Math.max(0, thumbStartX + deltaX), maxThumbLeft);

      customThumb.style.transform = `translateX(${newThumbLeft}px)`;

      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      if (maxScrollLeft <= 0) return;
      scrollContainer.scrollLeft = (newThumbLeft / maxThumbLeft) * maxScrollLeft;
    };

    // Mouse events
    customThumb.addEventListener('mousedown', (e) => {
      isDragging = true;
      dragStartX = e.clientX;
      thumbStartX =
        customThumb.getBoundingClientRect().left -
        customScrollbar.getBoundingClientRect().left;
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      const deltaX = e.clientX - dragStartX;
      moveThumb(deltaX);
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // Touch events
    customThumb.addEventListener(
      'touchstart',
      (e) => {
        isDragging = true;
        dragStartX = e.touches[0].clientX;
        thumbStartX =
          customThumb.getBoundingClientRect().left -
          customScrollbar.getBoundingClientRect().left;
        e.preventDefault();
      },
      { passive: false }
    );

    document.addEventListener(
      'touchmove',
      (e) => {
        if (!isDragging) return;
        const deltaX = e.touches[0].clientX - dragStartX;
        moveThumb(deltaX);
      },
      { passive: false }
    );

    document.addEventListener('touchend', () => {
      isDragging = false;
    });

    // Sync thumb position on scroll/resize/load
    scrollContainer.addEventListener('scroll', updateThumbPosition);
    window.addEventListener('resize', updateThumbPosition);
    window.addEventListener('load', updateThumbPosition);

    // Initial position
    updateThumbPosition();
  });

  document.querySelectorAll('.t4x-shopcat').forEach(container => {
    const cards = container.querySelectorAll('.t4x-shopcat__card');

    if (!cards.length) return;

    function updateCardOpacity() {
        const containerRect = container.getBoundingClientRect();

        cards.forEach(card => {
        const cardRect = card.getBoundingClientRect();
        const isVisible =
            cardRect.right > containerRect.left &&
            cardRect.left < containerRect.right;

        card.style.opacity = isVisible ? '1' : '0.1';
        });

        requestAnimationFrame(updateCardOpacity); // Keep loop running
    }

    requestAnimationFrame(updateCardOpacity);
    });


});

document.addEventListener('DOMContentLoaded', function () {
    var controller = null;
    var isInitialized = false;

    function initializeScrollMagic() {
        if (typeof jQuery !== 'undefined' && typeof ScrollMagic !== 'undefined') {
            jQuery(function () {
                if (controller) {
                    controller.destroy(true);
                    controller = null;
                    isInitialized = false;
                }

                controller = new ScrollMagic.Controller({
                    globalSceneOptions: {
                        triggerHook: 'onLeave',
                        duration: '400%'
                    }
                });

                var slides = document.querySelectorAll('.panel-section');

                slides.forEach(function (slide) {
                /*let offsetValue = -40;
                if (slide.id === 'sticky-contact-nav') {
                  offsetValue = -60;
                }*/

                    var scene = new ScrollMagic.Scene({
                        triggerElement: slide,
						            offset: 0
                    });

                    scene.setPin(slide, { pushFollowers: false });
                    scene.addTo(controller);
                });

                isInitialized = true;
            });
        } else {
            console.error("jQuery or ScrollMagic is not loaded.");
        }
    }

    function destroyScrollMagic() {
        if (controller) {
            controller.destroy(true);
            controller = null;
            isInitialized = false;
        }
    }

    function handleResize() {
        /*var isMobile = window.innerWidth <= 1023;

        if (isMobile) {
            destroyScrollMagic();
        } else if (!isInitialized) {
            initializeScrollMagic();
        }*/
		initializeScrollMagic();
    }

    handleResize();
    window.addEventListener('resize', handleResize);
});

// Schedule consultation calendar custom script
document.addEventListener('DOMContentLoaded', function () {
  function initPreferredDate() {
    const input = document.getElementById('form_input_9');
    if (!input || input._flatpickr) return;

    // Placeholder = today (e.g. 23 May 2024)
    const today = new Date();
    const formattedToday = today.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(',', '');

    input.placeholder = formattedToday;

    flatpickr(input, {
      dateFormat: "d M Y",
      minDate: "today",
      allowInput: false,
      clickOpens: true,
      disableMobile: true,

      /* Disable weekends
      disable: [
        function (date) {
          return date.getDay() === 0 || date.getDay() === 6;
        }
      ]*/
    });
  }

  initPreferredDate();

  // Hulk-safe retry
  let tries = 0;
  const interval = setInterval(() => {
    initPreferredDate();
    if (++tries > 10) clearInterval(interval);
  }, 400);
});
